module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="historyTitle"></div>\n<div class="history"></div>\n';

}
return __p
}